import { extractAccessToken } from '../common/helpers/local-storage';

export function getAdminPerformedBy(): string {
    try {
        const info = extractAccessToken();
        return info?.citizen_id ?? info?.username ?? '';
    } catch {
        return '';
    }
}

export function logAdminAction(
    sourceModule: string,
    actionType: string,
    targetId: string,
    sid: string,
    detail?: string
): void {
    fetch('/v1/admin-action-log', {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${localStorage.getItem('DMS_APPLICATION') ?? ''}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            sourceModule,
            actionType,
            targetId,
            performedBy: getAdminPerformedBy(),
            sid,
            detail,
        }),
    }).catch(() => {});
}
